import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const customEase = [0.16, 1, 0.3, 1];
  const steps = [{
    number: '01',
    title: 'Secure Your Spot',
    description: 'Book your preferred city and date online.'
  }, {
    number: '02',
    title: 'Pre-Class Prep',
    description: 'Receive your welcome guide and location details.'
  }, {
    number: '03',
    title: 'The Masterclass',
    description: '4 hours of hands-on, guided instruction.'
  }, {
    number: '04',
    title: 'Ongoing Support',
    description: 'Access to our private student community.'
  }];
  return <section className="py-16 md:py-20 bg-parchment texture-grain border-y border-cream-dark" data-id="element-253">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: customEase
      }} className="text-center mb-12" data-id="element-255">
          <h2 className="font-serif text-3xl md:text-4xl font-light text-ink" data-id="element-256">
            How It Works
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 relative" data-id="element-257">
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: customEase
        }} className="relative flex flex-col items-center text-center px-4" data-id="element-258">
              <div className="text-copper font-serif text-2xl italic mb-3" data-id="element-259">
                {step.number}
              </div>
              <h3 className="font-serif text-xl text-ink mb-2" data-id="element-260">{step.title}</h3>
              <p className="text-sm text-stone font-sans" data-id="element-261">{step.description}</p>

              {/* Arrow connector for desktop */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/4 -right-2 text-cream-dark text-2xl transform -translate-y-1/2" data-id="element-262">
                  &rarr;
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}